import { TextField } from "@mui/material";
import { ModalWrapper } from "../../../../../shared/components/ModalWrapper";
import CommonButtons from "src/shared/components/CommonButtons";

interface Props {
  email: string;
  onChange: (val: string) => void;
  onCancel: () => void;
  onUpdate: () => void;
  emailError: string;
}

export default function EmailModal({ email, onChange, onCancel, onUpdate, emailError }: Props) {
  return (
    <ModalWrapper title="Please enter the Email addressee" onClose={onCancel} width="max-w-xl w-full" className="min-w-[400px] text-center">
      <div className="space-y-6">
        <TextField
          className="w-full"
          label="Email ID"
          value={email}
          onChange={(e) => onChange(e.target.value)}
          error={!!emailError}
          helperText={emailError}
          variant="outlined"
        />
        <div className="flex justify-end gap-4">
          <CommonButtons className="w-36" variant="outlineDanger" label="Cancel" onClick={onCancel} />
          <CommonButtons className="w-36" label="Update" onClick={onUpdate} disabled={!email || !!emailError}
/>
        </div>
      </div>
    </ModalWrapper>
  );
}
